export const SITE = {
  name: "Empresa Brasil Online",
  shortName: "Empresa Brasil",
  tagline:
    "Gestão de empresas e negócios no Brasil: guias, análises e boas práticas para empreendedores e gestores.",
  description:
    "Portal editorial brasileiro sobre gestão de empresas e negócios: liderança, finanças, operações, pessoas, estratégia e crescimento aplicados ao contexto brasileiro.",
  baseUrl: "https://www.empresasbrasilonline.com.br",
  email: "svgmultimidia@gmail.com",
  social: {
    instagram: "https://www.instagram.com/",
    linkedin: "https://www.linkedin.com/",
    facebook: "https://www.facebook.com/",
  },
};

export const NAV = [
  { to: "/", label: "Início" },
  { to: "/blog", label: "Conteúdos" },
  { to: "/sobre", label: "Sobre" },
  { to: "/equipe", label: "Redação" },
  { to: "/contato", label: "Contato" },
] as const;
